import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface NewConversationModalStyleProps {
  maxHeight: number
}
const calcHeight = () => {
  return `${1.1}rem !important`
}

const useStyles = makeStyles<Theme, NewConversationModalStyleProps>(theme => ({
  modalTitle: {
    marginBottom: '0px',
    fontSize: theme.size.lg,
    color: '#1F1F1F'
  },

  modalClose: {
    top: '16px',
    right: '12px'
  },

  root: {
    maxWidth: 200
  },

  subtitle: {
    cursor: 'default',
    fontSize: theme.size.base,
    margin: '0'
  },

  channelSubtitle: {
    margin: '24px 0px 8px 0px'
  },

  messageSubtitle: {
    margin: '16px 0px 8px 0px'
  },

  messageRoot: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #C6C6C6',
    borderRadius: '4px',
    boxSizing: 'border-box',
    padding: '0 16px 16px 16px',
    background: '#F5F6F8',
    transition: 'all 250ms',

    [theme.breakpoints.down('lg')]: {
      flex: 1
    }
  },

  inputRoot: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('lg')]: {
      flex: 1,
      maxHeight: ({ maxHeight }) => maxHeight && `calc(${maxHeight}px - 6px)`
    },

    '& .chat-input': {
      boxSizing: 'border-box',
      cursor: 'text',
      marginTop: 24,
      maxHeight: 'calc(calc(20px * 6) + 12px)',
      minHeight: 'calc(calc(20px * 6) + 12px)',
      overflowY: 'auto',
      padding: 6,
      color: '#1f1f1f'
    }
  },
  mentionInputClass: {
    boxSizing: 'border-box',
    cursor: 'text',
    marginTop: 12,
    overflowY: 'auto',
    color: '#1f1f1f'
  },

  input: {
    marginTop: '24px',

    '& .text > div': {
      height: calcHeight
    },

    '& .text > div > div': {
      height: calcHeight,
      padding: '0 !important'
    },

    '& .text > div > textarea': {
      padding: '0 !important',
      '&::-webkit-scrollbar': {
        width: 8
      },

      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 0
      }
    }
  },

  editorRoot: {
    '& .public-DraftEditorPlaceholder-root': {
      color: '#888888 !important'
    },

    [theme.breakpoints.down('lg')]: {
      maxHeight: ({ maxHeight }) => maxHeight && `calc(${maxHeight}px - 6px)`
    }
  },

  button: {
    width: '164px',
    height: 48,
    marginLeft: 8,

    [theme.breakpoints.down('lg')]: {
      marginLeft: 0,
      width: '100%'
    }
  },

  cannedButton: {
    display: 'grid',
    placeItems: 'center',
    marginRight: '8px',
    borderRadius: '6px',
    padding: '5px',
    background: '#b5b5b5', // theme.palette.primary.main,
    cursor: 'default'
  },

  returnIcon: {
    paddingRight: 16
  },

  inputControlsRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '20px'
  },

  iconButtonBlock: {
    display: 'flex',
    alignItems: 'center'
  },

  iconButton: {
    cursor: 'pointer',

    '&:not(:last-child)': {
      marginRight: '4px'
    }
  },

  sendBlock: {
    display: 'flex',
    alignItems: 'center'
  },

  sendButton: {
    width: 'auto',
    height: 20
  },

  holder: {
    position: 'relative'
  },

  count: {
    textAlign: 'right',
    marginBottom: '-10px',
    marginTop: 8,
    color: 'grey',
    fontSize: theme.size.sm
  }
}))

export default useStyles
